module.exports = {"350627100":"山城镇","350627101":"丰田镇","350627102":"靖城镇","350627103":"龙山镇","350627104":"金山镇","350627105":"和溪镇","350627106":"奎洋镇","350627107":"梅林镇","350627108":"书洋镇","350627109":"船场镇","350627110":"南坑镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350627.json
// module id = 1328
// module chunks = 0